import {
  EListActiveChildItem,
  EListActiveEntry,
  EListEntryId,
  EListItemEntry,
} from './types';

export const isActiveItem = (
  itemId: EListEntryId,
  activeItem: EListActiveEntry | undefined
): boolean =>
  activeItem && isActiveEntryChildItem(activeItem)
    ? itemId === activeItem.parentId || itemId === activeItem.childId
    : itemId === activeItem;

export const isActiveEntryChildItem = (
  activeItem: EListActiveEntry | undefined
): activeItem is EListActiveChildItem =>
  activeItem !== undefined &&
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  (activeItem as EListActiveChildItem).childId !== undefined;

/** Verifies whether the passed active items are identical, either by reference or by (deep) value. */
export const isEqualActiveItem = (
  activeItem: EListActiveEntry | undefined,
  userActiveItem: EListActiveEntry | undefined
): boolean =>
  activeItem === userActiveItem ||
  (isActiveEntryChildItem(activeItem) &&
    isActiveEntryChildItem(userActiveItem) &&
    activeItem.parentId === userActiveItem.parentId &&
    activeItem.childId === userActiveItem.childId);

/** function to create all possible items shown in the filter list, it is assuemed that the elements are ordered */
export const buildSectionedItemList = <T extends object>(
  data: EListItemEntry<T>[]
): EListItemEntry<T>[] => {
  let currentStickySectionId = '';
  let currentSectionId = '';
  const elements: EListItemEntry<T>[] = [];
  data.forEach((item) => {
    // insert section header entry for first occurrence of elements with new sectionHeader
    if (
      item.sectionHeaderId &&
      item.sectionHeaderComponent &&
      item.sectionHeaderId !== currentSectionId
    ) {
      elements.push({
        id: item.sectionHeaderId,
        raw: item.raw,
        options: {isActivatable: false, isSelectable: false},
        Component: item.sectionHeaderComponent,
      });
      currentSectionId = item.sectionHeaderId;
    }
    // insert sticky header entry for first occurrence of elements with new stickyHeaderId
    if (
      item.stickyHeaderId &&
      item.stickyHeaderComponent &&
      item.stickyHeaderId !== currentStickySectionId
    ) {
      elements.push({
        id: item.stickyHeaderId,
        raw: item.raw,
        stickyHeaderId: item.stickyHeaderId,
        options: {
          isActivatable: false,
          isSelectable: false,
          singleActions: item.stickyHeaderActions,
        },
        Component: item.stickyHeaderComponent,
      });
      currentStickySectionId = item.stickyHeaderId;
    }
    elements.push(item);
  });
  return elements;
};

export const getNextSelectableEntry = <T extends object>(
  data: EListItemEntry<T>[],
  currentItemIndex: number,
  backward: boolean
): EListItemEntry<T> | undefined => {
  if (backward) {
    for (let i = currentItemIndex - 1; i >= 0; i--) {
      if (data[i]?.options?.isSelectable !== false) {
        return data[i];
      }
    }
  } else {
    for (let i = currentItemIndex + 1; i < data.length; i++) {
      if (data[i]?.options?.isSelectable !== false) {
        return data[i];
      }
    }
  }

  return undefined;
};
